var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-section-header"},[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-medium"}}),_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t(_vm.title)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }